import React from "react";

import { UseFormReturn } from "react-hook-form";
import {
    Box, Button, Typography
} from "@mui/material";

import {
    t,
    Trans
} from "@lingui/macro";
import NavigationBack from "commons/navigation/navigation-back/navigation-back";
import { ManageTagState } from "./models";
import ZPlayLoader from "../../../commons/zplay-loader";
import { DefaultTypedResponse } from "../../../models/response/default-typed-response";
import { Tag } from "../../../models/tag";
import { ContentProducerService } from "../../../services/content-producer-service";
import AddIcon from "@mui/icons-material/Add";
import { withSnackbar, WithSnackbarProps } from "notistack";
import { CreateAndEditTagModal, TagTable } from "components/backoffice/tag";

class ManageTag extends React.Component<UseFormReturn & WithSnackbarProps, ManageTagState>{

    constructor(props: any) {
        super(props);

        this.state = {
            searchFilter: null,
            pagination: { pageSize: 20, pageIndex: 0 },
            tagCount: 0,
            tagList: [],
            data: null,
            isLoading: true,
            openEditTagModal: false,
            openCreateTagModal: false,
            editTag: null
        };
    }

    public componentDidMount() {
        this.getPaginatedTagWithStateParameters();
    };

    private paginationUpdated = (pagination: any) => {

        ////****
        //VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
        ////****

        this.setState(() => ({
            isLoading: true,
            pagination: pagination
        }), () => ContentProducerService.getTagListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getTagCallback, this.getTagErrorCallback));

    }

    private getPaginatedTagWithStateParameters = () => {

        this.setState(() => ({
            isLoading: true,
        }));

        ContentProducerService.getTagListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getTagCallback, this.getTagErrorCallback);
    }

    private deleteTag = (id: string): void => {

        this.setState(() => ({
            isLoading: true,
        }));

        if ((this.state.tagList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    pageIndex: this.state.pagination.pageIndex - 1
                }
            }));
        }

        ContentProducerService.deleteTag(id, this.getPaginatedTagWithStateParameters, this.deleteTagErrorCallback);
    }


    private getTagCallback = (data: DefaultTypedResponse<Tag>): void => {

        this.setState(() => ({
            tagCount: data.size,
            tagList: data.list,
            isLoading: false,
        }));
    };

    private editTagCallback = (): void => {
        this.setState(() => ({ openEditTagModal: false }));
        this.getPaginatedTagWithStateParameters();
    };

    private createTagCallback = (): void => {
        this.setState(() => ({ openCreateTagModal: false }));
        this.getPaginatedTagWithStateParameters();
    };

    private deleteTagErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mt-error-delete-tag",
            message: "Si è verificato un errore. Il tag non è stato eliminato"
        }), {
            variant: "error",
        });
    }

    private getTagErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));


        this.props.enqueueSnackbar(t({
            id: "mt-error-get-tag",
            message: "Si è verificato un errore."
        }), {
            variant: "error",
        });
    };

    private editTagErrorCallback = (err: any): void => {
        this.setState(() => ({
            openEditTagModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mt-error-edit-tag",
            message: "Si è verificato un errore. Il tag non è stato modificato"
        }), {
            variant: "error",
        });
    };

    private createTagErrorCallback = (err: any): void => {
        this.setState(() => ({
            openCreateTagModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mt-error-create-tag",
            message: "Si è verificato un errore. Il tag non è stato creato"
        }), {
            variant: "error",
        });
    };


    private openEditTagModal = (tag: Tag): void => {
        this.setState(() => ({
            openEditTagModal: true,
            editTag: tag
        })
        )
    }

    private closeEditTagModal = (): void => {
        this.setState(() => ({
            openEditTagModal: false,
            editTag: null,
            openCreateTagModal: false
        }));
    };

    private openCreateTagModal = (): void => {
        this.setState(() => ({
            openCreateTagModal: true,
        })
        )
    }

    render() {
        return (
            <Box sx={{ textAlign: "center", p: 5 }}>
                <NavigationBack/>
                <Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                    <Trans id="mt-text-title">Tag</Trans>
                </Typography>
                <Box sx={{ textAlign: "right", pr: 2 }}>
                    <Button
                        endIcon={<AddIcon />}
                        onClick={this.openCreateTagModal}
                        variant={"contained"}
                    >
                        <Trans id="mt-button-add">Aggiungi</Trans>
                    </Button>
                </Box>
                {<Box sx={{ p: 2, mt: 2 }}>
                    <TagTable
                        pagination={this.state.pagination}
                        tags={this.state.tagList}
                        totalTagCount={this.state.tagCount}
                        deleteTag={this.deleteTag}
                        openEditTagTable={this.openEditTagModal}
                        updatePaginationCallBackFn={this.paginationUpdated}
                    />
                </Box>}
                {this.state.openEditTagModal && <CreateAndEditTagModal
                    closeModal={this.closeEditTagModal}
                    editTagCallback={this.editTagCallback}
                    editTagErrorCallback={this.editTagErrorCallback}
                    tag={this.state.editTag}
                />}
                {this.state.openCreateTagModal && <CreateAndEditTagModal
                    closeModal={this.closeEditTagModal}
                    createTagCallback={this.createTagCallback}
                    createTagErrorCallback={this.createTagErrorCallback}
                />}
                {this.state.isLoading && <ZPlayLoader />}
            </Box>);
    }
}

export default withSnackbar(ManageTag);